var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"icon-secondary"},on:{"click":function($event){return _vm.$emit(`click`)}}},[_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-cog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }